/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';

/**
 * Default feature flags — used as base values, merged with server-side cockpitSettings during login.
 */
export const DEFAULT_FEATURE_FLAGS = {
  // STRING FEATURES
  logo: 'stage',
  theme: 'dark',
  newsletterBanner: '',
  newsletterLogo: '',
  newsletterDisclaimer: '',
  newsletterEmail: '',
  // NUMBER FEATURES
  collectionsLimit: 15,
  queriesPerCollectionsLimit: 30,
  portfoliosLimit: 100,
  entitiesPerPortfoliosLimit: 10000,
  // BOOLEAN FEATURES
  activityLogging: true,
  betaLanguages: false,
  importExportBookmarks: false,
  showTopNews: false,
  // invest lab options
  showInvestLab: true,
  showSignals: true,
  showTrending: true,
};

/**
 * Default scorelab settings — used as base values, merged with server-side settings during login.
 */
export const DEFAULT_SCORELAB_SETTINGS = {
  sentimentAccess: true,
  generalRiskAccess: false,
  creditRiskAccess: false,
  esgRiskAccess: false,
  immediateRiskAccess: false,
  esgAccess: false,
  eb_simAccess: false,
  bbAccess: false,
  customScoreAccess: false,
  defaultScore: 'sentiment',
  customScores: [] as any[],
};

/**
 * Default admin scorelab settings — full access enabled.
 */
export const DEFAULT_ADMIN_SCORELAB_SETTINGS = {
  sentimentAccess: true,
  generalRiskAccess: true,
  creditRiskAccess: true,
  esgRiskAccess: true,
  immediateRiskAccess: true,
  esgAccess: true,
  eb_simAccess: false,
  bbAccess: true,
  customScoreAccess: true,
  defaultScore: 'sentiment',
  customScores: [] as any[],
};

/**
 * Centralized user state service.
 * Owns the shared BehaviorSubject-like state that was previously scattered across AuthService.
 * AuthService delegates to this service via getter/setter proxies.
 */
@Injectable({
  providedIn: 'root',
})
export class UserStateService {
  /** Entities sent as array in request body */
  payloadEntities: any[] = [];

  /** Active filter id (set by menu-filters; read by newsfeed/view). */
  filter: any;

  /** Custom default filter object (set by filters.guard from saved settings). */
  defaultFilter: any;
  /** Set by filters.guard after its one fetch, so it doesn't re-fetch per route activation. */
  defaultFilterChecked = false;

  scoreFocusedEventsAnalytics: any = null;

  /**
   * Reset all state to defaults (called on logout).
   */
  reset(): void {
    this.payloadEntities = [];
    this.filter = undefined;
    this.defaultFilter = undefined;
    this.defaultFilterChecked = false;
    this.scoreFocusedEventsAnalytics = null;
  }
}
